import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentTree } from "slices/efficeTreeSlice";
import RenderedRootSingle from "./RenderedRootSingle/RenderedRootSingle";

const RenderedRootList = ({ currentActiveAlive }) => {
  const currentTree = useSelector(selectCurrentTree);

  let items = [];
  for (let id in currentTree) {
    items.push(
      <RenderedRootSingle
        key={id}
        id={id}
        currentActiveAlive={currentActiveAlive}
      />
    );
  }
  if (items.length === 0)
    return <div className="no-root-tip">Your effices will appear here</div>;
  else return items;
};

export default RenderedRootList;
